import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSprite,
  OptionItemSpriteList,
} from '@/pages/Onboarding/components/OptionItemSprite/OptionItemSprite';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { ETHNICITY_OPTIONS } from '@/pages/Onboarding/options/Ethnicity';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../../types';

import { EthnicityMaleStyles } from './EthnicityMale.styles';

export const ScreenEthnicity: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Ethnicity',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const ethnicity = form.watch('ethnicity');
  const age = form.watch('age');

  const handleBackStep = () => {
    wizard.goToStep('age');
  };

  const handleNextStep = () => {
    wizard.goToStep('body_shape');
  };

  const handleSelect = (option: OnbOptionType<LayoutDataType['ethnicity']>) => {
    form.setValue('ethnicity', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        ethnicity: option.title,
      },
    });
    nextStepTimeout(handleNextStep);
  };

  return (
    <EthnicityMaleStyles>
      <OnboardingNavigation onBack={handleBackStep} />
      <OwnAiTitle>
        Select his <OwnAiTitleHighlight>ethnicity</OwnAiTitleHighlight>
      </OwnAiTitle>

      <IonContent>
        <OptionItemSpriteList>
          {ETHNICITY_OPTIONS.map((option) => (
            <OptionItemSprite
              key={option.id}
              alt="ethnicity"
              isSelected={ethnicity === option.id}
              onClick={() => handleSelect(option)}
              spriteSrc={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-man/ethnicity/sprite-${age}-${option.id}.png`}
              title={option.title}
              TEST_ID={`ethnicity-${option.id}`}
              show
            />
          ))}
        </OptionItemSpriteList>
      </IonContent>
    </EthnicityMaleStyles>
  );
};
